import React from 'react';

const LabelDisplay =({ title, description, className="flex mt-[2px]", showVertical=false })=> {
  return (

      <div className={`gap-1 py-1 ${className} ${showVertical ? "flex flex-col items-start" : "items-center"}`}>
        <div className="font-light flex flex-col leading-none  text-neutral-900">
          <div>{title}:</div>
        </div>
        <div className={`flex-1 shrink leading-5 basis-0`}>{description ?? "N/A"}</div>
      </div>
  );
}

export default LabelDisplay;
